module.exports = __webpack_public_path__ + "ef45e924f80edb81568e998e4a935012.png";